import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { RegisterUserStamp } from '../../business-entities/register-user-stamp';
import { UserClockInOutResponseModel } from '../../business-entities/user-clock-in-out-response-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { Features } from '../../business-entities/user-role-view-model';
import { UserClockInOutService } from '../../business-services/user-clock-in-out.service';
import { AddUserClockInOutComponent } from './add-user-clock-in-out/add-user-clock-in-out.component';

@Component({
  selector: 'app-user-clock-in-out',
  templateUrl: './user-clock-in-out.component.html',
})
export class UserClockInOutComponent implements OnInit {
  userClockInOutList: UserClockInOutResponseModel[];
  features: Features[] = [];

  paginationSub: Subscription;
  subscription: Subscription;
  total$: Observable<number>;
  userList: { userId: string, name: string, locationName: string } [] = [];
  locationCodeList: {locationCode: string, locationName: string}[]=[]; 
  userRoleRightsDetails: UserRoleMenu;
  isAddUserClockInOut: boolean = false;
  stampInOut: any;

  requestModel: RegisterUserStamp = {
    id: 0,
    stampIn: null,
    stampOut: null,
    userId: null,
    users: null,
    location: null,
    createdBy: null,
    isDeleted: false,
    isManualOperation: false,
    isAdvanceSearch: false,
    startRecordNumber: 0,
    PageSize: 25,
    SortColumn: '',
    sortDirection: 'DESC',
  };

  selectedLocation: {locationCode: string, locationName: string}[]=[]; ;
  selectedUsers: { userId: string, name: string }[] = [];
  filterUserList: { userId: string, name: string }[] = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    maxHeight: 500,
  };
  dropdownSettingForLocation = {
    singleSelection: true,
    idField: 'locationCode',
    textField: 'locationName', 
    itemsShowLimit: 1,
    allowSearchFilter: true,
    maxHeight: 500,
  }
  todayDate: Date = new Date();
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private userClockInOutService: UserClockInOutService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private userService: UserDataService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private dataProvider: DataService
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['name', 'role'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.pService.dataSource = [];
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === Enums.ModuleNames.UserClockInOut);
    this.getFeatures();
    this.getLocationList();
    this.getUsers();
    this.getUserClockInOutList();
  }

  public getUserClockInOutList() {
    this.spinner.show();
    this.userClockInOutService
      .getUserClockInOut(this.requestModel)
      .then((response) => {
        if (response) {
          this.pService.dataSource = response;
          this.paginationSub = this.pService.dealers$.subscribe((result) => {
            this.userClockInOutList = this.userClockingDataMapper(result);
          });
          this.total$ = this.pService.total$;
          this.spinner.hide();
        } else if (
          response.responseObject &&
          response.responseObject.errorCount > 0
        ) {
          if (
            response.responseObject.result &&
            response.responseObject.result.errorCode ===
              Enums.ErrorCodes.ServiceCategoriesCode
          ) {
            this.spinner.hide();
          }
        }
        this.spinner.hide();
      })
      .catch((err) => {
        this.spinner.hide();
      });
  }

  public onAdvanceSearch() {
    this.requestModel.isAdvanceSearch = true;
  }

  public AdvanceSearchSubmit() {
    this.requestModel.stampIn = this.stampInOut
      ? this.stampInOut.beginJsDate
      : null;
    this.requestModel.stampOut = this.stampInOut
      ? this.stampInOut.endJsDate
      : null;
    this.requestModel.stampIn?.setDate(this.requestModel.stampIn?.getDate() + 1);
    this.requestModel.stampOut?.setDate(this.requestModel.stampOut?.getDate() + 1);
    this.requestModel.isAdvanceSearch = true;
    this.requestModel.startRecordNumber = 0;
    this.getUserClockInOutList();
    this.requestModel.isAdvanceSearch = false;
  }

  public onReset() {
    this.requestModel.isAdvanceSearch = false;
    this.stampInOut = null;
    this.requestModel.stampIn = null;
    this.requestModel.stampOut = null;
    this.requestModel.startRecordNumber = 0;
    this.getUserClockInOutList();
  }

  public onClose() {
    this.requestModel.isAdvanceSearch = false;
  }

  public onUserSelected() {
    this.requestModel.users = this.selectedUsers.map(x => x.userId);
    this.getUserClockInOutList();
  }

  public onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  public onAdd() {
    this.userClockInOutService.userClockInOutId = 0;
    this.userClockInOutService.isEdit = false;
    const modalref = this.modalService.open(AddUserClockInOutComponent, {
      size: 'md',
      windowClass: 'EditPopup',
    });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  public onEdit(id: number) {
    this.userClockInOutService.userClockInOutId = id;
    this.userClockInOutService.isEdit = true;
    const modalref = this.modalService.open(AddUserClockInOutComponent, {
      size: 'md',
      windowClass: 'EditPopup',
    });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  public onDelete(id: number) {
    const userData = this.secureStorage.getKeyData(
      fromEnums.SecureStorageKey.GetUserDetails
    );
    const userStampData = {
      id: id,
      userId: userData.userId,
      createdBy: userData.userId,
      isManualOperation: true,
      isDeleted: true,
    };
    this.setUserStampInOut(userStampData);
  }

  onLocationSelection(){
    this.filterUserList = this.userList;
    if(this.selectedLocation.length>0){
      this.filterUserList = this.userList.filter(x => 
        x.locationName === this.selectedLocation[0].locationName
      );

      this.requestModel.location = this.selectedLocation[0].locationName;
      this.getUserClockInOutList();
    }
    else{
      this.filterUserList = this.userList;
      this.requestModel.location = null;
      this.getUserClockInOutList();
    } 
  }

  private getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe(
        (res) => {
          this.features = res;
          this.updateFeatureFlagValue();
        }
      );
    }
    this.updateFeatureFlagValue();
  }

  private async getLocationList() {
    this.spinner.show();
    this.selectedLocation = [];
    await this.userClockInOutService
      .GetLocationCode()
      .then((response) => {
        this.locationCodeList = response.responseObject; 
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private async getUsers() {
    this.spinner.show();
    this.selectedUsers = [];
    await this.userClockInOutService
      .getUsers()
      .then((response) => {
        this.userList = response;
        this.filterUserList = response; 
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  private userClockingDataMapper(clockingList: any) {
    let supperArray = [];
    if (clockingList && clockingList.length > 0) {
      for (let index = 0; index < clockingList.length; index++) {
        const element = clockingList[index];
        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.name = element.name;
        single.role = element.role;
        single.locationName = element.locationName;
        single.comment = element.comment;
        single.stampIn = Utility.ConvertUTCDateToLocalDate(element.stampIn);
        single.stampOut = element.stampOut
          ? Utility.ConvertUTCDateToLocalDate(element.stampOut)
          : element.stampOut;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    } else if (this.pService.page > 1) {
      rtPageNumber =
        Number.parseInt(
          `${this.pService.pageSize * (this.pService.page - 1)}`
        ) +
        (cIndex + 1);
    }

    return rtPageNumber;
  }

  private updateFeatureFlagValue() {
    if (this.features?.length > 0) {
      this.isAddUserClockInOut = this.features.find(
        (x) => x.featureCode === Enums.FeatureCode.UserStampInOut
      )?.isActive;
    }
  }

  private setUserStampInOut(registerUserStamp: any) {
    this.spinner.show();
    this.dataProvider
      .Post<any>(Urls.RegisterUserStamp, registerUserStamp)
      .toPromise()
      .then(async (response) => {
        this.spinner.hide();
        if (response.responseCode === Constant.SuccessResponseCode) {
          this.toastr.success(
            this.translate.instant('lblUserStampDeleteSuccess')
          );
          this.getUserClockInOutList();
        } else {
          this.toastr.error(this.translate.instant('lblUserStampDeleteFail'));
        }
      })
      .catch((err) => {
        this.spinner.hide();
      });
  }
}
